
























import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    url: {
      type: String,
      required: true,
    },
    close: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
});
